import * as angular from "angular";

export class ConsentTypeService {
    private apiRoot: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = "/v2/consenttype";
    }

    all(data?: any): Promise<object> {
        return this.$http.get(this.apiRoot, data);
    }

    create(data: any): Promise<object> {
        return this.$http.post(this.apiRoot, data);
    }

    update(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/" + data.id, data);
    }

    delete(data: any): Promise<object> {
        return this.$http.delete(this.apiRoot + "/" + data.id, data);
    }

    deactivate(data: any): Promise<object> {
        return this.$http.delete(this.apiRoot + "/deactivate" + data.id, data);
    }
}

angular.module("vcServices").service("ConsentTypeService", ConsentTypeService);
